export default __webpack_public_path__ + "static/media/9_3.9b06b03b.png";